import { AxiosRequestConfig } from 'axios'

const getMembershipsPrizes = (membershipId: number): AxiosRequestConfig => ({
  url: `/memberships/${membershipId}/prizes`,
  method: 'GET',
})

export { getMembershipsPrizes }
